(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blocobox-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-contact-drawer')) {
    class BlocoboxContactDrawer extends HTMLElement {
      connectedCallback() {
        this.bootFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abortController || !this.isConnected) return;
        this.trigger = this.querySelector('.bb-contact__trigger');
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-close]');
        this.feedback = this.querySelector('[data-feedback]');
        if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.schedule = this.schedule || (() => {
          if (!this.frame && this.isConnected) {
            this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
          }
        });
        this.refreshTargets();
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.watchBarSizes();
        this.observer = new MutationObserver((records) => {
          let changed = false;
          let refresh = false;
          for (const record of records) {
            if (record.target === this || this.contains(record.target)) continue;
            changed = true;
            if (record.type === 'childList') refresh = true;
          }
          if (refresh) {
            this.refreshTargets();
            this.watchBarSizes();
            this.subscribeUpcart();
          }
          if (changed) this.schedule();
        });
        this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'inert'] });
        this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
        for (const event of ['scroll', 'resize', 'pageshow', 'load']) window.addEventListener(event, this.schedule, { passive: true, signal });
        for (const event of ['focusin', 'focusout', 'transitionend']) document.addEventListener(event, this.schedule, { signal });
        document.addEventListener('variant:change', (event) => {
          if (String(event.detail?.product?.id) !== this.dataset.productId) return;
          this.currentVariantId = event.detail?.variant?.id ? String(event.detail.variant.id) : '';
          this.updateLinks();
        }, { signal });
        window.addEventListener('pagehide', () => this.closeDrawer(false), { signal });
        window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
        window.visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal });
        this.trigger.addEventListener('click', () => this.openDrawer(), { signal });
        this.closeButton.addEventListener('click', () => this.closeDrawer(), { signal });
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDrawer(); }, { signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.finishClose(false); }, { signal });
        this.dialog.addEventListener('pointerdown', (event) => { this.backdropStarted = this.isBackdropClick(event); }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (this.backdropStarted && this.isBackdropClick(event)) this.closeDrawer();
          this.backdropStarted = false;
        }, { signal });
        for (const link of this.links) link.addEventListener('click', () => this.updateLinks(), { signal });
        this.querySelectorAll('[data-copy-code]').forEach((button) => button.addEventListener('click', () => this.copyCoupon(button), { signal }));
        if (window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          section?.addEventListener('shopify:section:select', () => this.openDrawer(), { signal });
          section?.addEventListener('shopify:section:deselect', () => this.closeDrawer(false), { signal });
          section?.addEventListener('shopify:block:select', (event) => {
            this.openDrawer();
            event.target.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }, { signal });
        }
        this.subscribeUpcart();
        if (!this.upcartSubscribed) {
          let attempts = 0;
          this.upcartTimer = setInterval(() => {
            this.subscribeUpcart();
            if (this.upcartSubscribed || ++attempts >= 60) clearInterval(this.upcartTimer);
          }, 1000);
        }
        this.update();
        if (window.Shopify?.designMode && window.bbContactEditorSection === this.dataset.sectionId) this.openDrawer();
      }

      disconnectedCallback() {
        const reopenInEditor = window.Shopify?.designMode && this.dialog?.open;
        this.closeDrawer(false);
        if (reopenInEditor) window.bbContactEditorSection = this.dataset.sectionId;
        this.abortController?.abort();
        this.abortController = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearInterval(this.upcartTimer);
        cancelAnimationFrame(this.bootFrame);
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      refreshTargets() {
        this.bars = [...document.querySelectorAll('product-quick-add.product-quick-add')];
        this.controls = [...document.querySelectorAll('#main button, #main input:not([type="hidden"]), #main select, #main textarea, #main a.button, #main [role="button"]')];
        this.links = [...this.querySelectorAll('[data-whatsapp-link]')];
      }

      watchBarSizes() {
        this.resizeObserver?.disconnect();
        this.bars.forEach((bar) => this.resizeObserver?.observe(bar));
      }

      subscribeUpcart() {
        if (this.upcartSubscribed || typeof window.upcartSubscribeCartOpened !== 'function' || typeof window.upcartSubscribeCartClosed !== 'function') return;
        window.upcartSubscribeCartOpened(() => {
          this.upcartOpen = true;
          if (!this.isConnected) return;
          this.closeDrawer(false);
          this.setTriggerHidden(true);
        });
        window.upcartSubscribeCartClosed(() => { this.upcartOpen = false; this.schedule(); });
        this.upcartSubscribed = true;
        clearInterval(this.upcartTimer);
      }

      updateLinks() {
        if (!/^[1-9]\d{7,14}$/.test(this.dataset.phone || '')) return;
        for (const link of this.links) {
          let message = link.dataset.message || '';
          if (this.dataset.productUrl) {
            const productUrl = new URL(this.dataset.productUrl);
            const urlVariant = new URL(window.location.href).searchParams.get('variant');
            const variant = this.currentVariantId ?? urlVariant ?? this.dataset.variantId;
            if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
            message = message.replace(this.dataset.productUrl, productUrl.href);
          }
          const href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(message);
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      }

      hasBlockingOverlay() {
        if (this.upcartOpen || document.documentElement.classList.contains('lock')) return true;
        const htmlStyle = getComputedStyle(document.documentElement);
        const bodyStyle = getComputedStyle(document.body);
        if (bodyStyle.position === 'fixed') return true;
        if (!this.ownsScrollLock && (htmlStyle.overflowY === 'hidden' || bodyStyle.overflowY === 'hidden')) return true;
        return [...document.querySelectorAll('.drawer[open], .modal[open], dialog[open], .pswp--open')].some((overlay) => overlay !== this.dialog);
      }

      openDrawer() {
        if (!this.dialog || this.dialog.open || !this.isConnected || this.hasBlockingOverlay()) return;
        this.updateLinks();
        this.dialog.showModal();
        this.ownsScrollLock = true;
        document.documentElement.classList.add('bb-contact-scroll-lock');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.setTriggerHidden(true);
        this.closeButton.focus({ preventScroll: true });
        if (window.Shopify?.designMode) window.bbContactEditorSection = this.dataset.sectionId;
      }

      closeDrawer(restoreFocus = true) {
        const wasOpen = this.dialog?.open;
        if (wasOpen) this.dialog.close();
        this.finishClose(restoreFocus && wasOpen);
      }

      finishClose(restoreFocus) {
        if (this.dialog?.open) return;
        if (this.ownsScrollLock) {
          document.documentElement.classList.remove('bb-contact-scroll-lock');
          this.ownsScrollLock = false;
        }
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.copySession = (this.copySession || 0) + 1;
        if (this.feedback) this.feedback.textContent = '';
        this.querySelectorAll('[data-copy-code]').forEach((button) => {
          button.disabled = false;
          button.textContent = button.dataset.originalText;
        });
        if (window.bbContactEditorSection === this.dataset.sectionId) window.bbContactEditorSection = null;
        if (this.isConnected && this.trigger) {
          this.update();
          if (restoreFocus && !this.trigger.inert) this.trigger.focus({ preventScroll: true });
        }
      }

      isBackdropClick(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      async copyCoupon(button) {
        const code = button.dataset.copyCode;
        if (!code || button.disabled) return;
        const session = this.copySession || 0;
        button.disabled = true;
        this.feedback.textContent = '';
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (!this.isConnected || !this.dialog.open || session !== (this.copySession || 0)) return;
          button.textContent = this.dataset.copied;
          this.feedback.textContent = this.dataset.copySuccess;
        } catch {
          if (!this.isConnected || !this.dialog.open || session !== (this.copySession || 0)) return;
          this.feedback.textContent = this.dataset.copyError;
          const input = button.closest('.bb-contact__card')?.querySelector('.bb-contact__coupon-code');
          input?.focus({ preventScroll: true });
          input?.select();
        } finally {
          button.disabled = false;
        }
      }

      setTriggerHidden(hidden) {
        this.trigger.toggleAttribute('data-bb-hidden', hidden);
        this.trigger.inert = hidden;
      }

      intersects(a, b, gap = 8) {
        return b.width > 0 && b.height > 0 && a.left < b.right + gap && a.right > b.left - gap && a.top < b.bottom + gap && a.bottom > b.top - gap;
      }

      isControlVisible(control) {
        if (typeof control.checkVisibility === 'function') return control.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true, contentVisibilityAuto: true });
        const visibility = getComputedStyle(control).visibility;
        if (visibility === 'hidden' || visibility === 'collapse') return false;
        for (let element = control; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || parseFloat(style.opacity) === 0 || style.contentVisibility === 'hidden') return false;
        }
        return true;
      }

      update() {
        if (!this.isConnected || !this.trigger || !this.dialog) return;
        this.updateLinks();
        if (this.hasBlockingOverlay()) {
          if (this.dialog.open) this.closeDrawer(false);
          this.setTriggerHidden(true);
          return;
        }
        if (this.dialog.open) { this.setTriggerHidden(true); return; }
        const editing = document.activeElement?.matches('input:not([readonly]), textarea:not([readonly]), select, [contenteditable="true"]');
        if (editing) { this.setTriggerHidden(true); return; }
        let clearance = 0;
        const originalRect = this.trigger.getBoundingClientRect();
        for (const bar of this.bars) {
          if (!bar.classList.contains('is-visible') || getComputedStyle(bar).display === 'none') continue;
          const rect = bar.getBoundingClientRect();
          if (originalRect.left < rect.right && originalRect.right > rect.left) clearance = Math.max(clearance, bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) + 12);
        }
        const value = Math.ceil(clearance) + 'px';
        if (this.trigger.style.getPropertyValue('--bb-clearance') !== value) this.trigger.style.setProperty('--bb-clearance', value);
        const rect = this.trigger.getBoundingClientRect();
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const hidden = viewportHeight < 300 || rect.top < 90 || this.controls.some((control) => this.intersects(rect, control.getBoundingClientRect()) && this.isControlVisible(control));
        this.setTriggerHidden(hidden);
      }
    }
    customElements.define('bb-contact-drawer', BlocoboxContactDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
